<div class="forgotPassword">
    <div class="container-fluid">
        <div class="row">
            <div class="shape">
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 1440 120">
                    <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
                </svg>
            </div>
            <div class="DivOuter">
                <div class="forgotpass-panel">
                    <div class="logo-panel">
                        <img src="https://pmt-bucket2026.s3.eu-west-2.amazonaws.com/prod/pmt-logo.png" alt="csc" />
                    </div>
                    <h1>Forgot Your Password?</h1>
                    <h3>Reset Password with <span>PMT PLUS</span></h3>
                    <h5 *ngIf="!linkGenerated">
                        Enter your Email and instructions will be sent to you!
                    </h5>

                    <div *ngIf="!linkGenerated" class="col">
                        <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
                            <div class="form-group">
                                <label class="required-field">Email address</label>
                                <input type="email" class="form-control" formControlName="email"
                                    placeholder="Enter email" />
                                <div class="ErrorMessageSection">
                                    <p *ngIf="submitted && forgotPasswordForm.get('email')?.hasError('required')">
                                        Please enter your email
                                    </p>
                                    <p
                                        *ngIf="submitted && forgotPasswordForm.get('email')?.hasError('email') && !forgotPasswordForm.get('email')?.hasError('required')">
                                        Please enter a correct Email ID
                                    </p>
                                </div>
                            </div>
                            <div class="btn-groups">
                                <button class="btn btn-secondary" type="button" routerLink="/">
                                    Back
                                </button>
                                <button class="btn btn-success ml-3" type="submit"
                                    [disabled]="forgotPasswordForm.pristine">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                    <div *ngIf="linkGenerated" class="sent-reet-link">
                        <div class="form-group">
                            <p class="text-center text-success font-weight-bold">
                                A link has been sent to you to reset your password. Please visit
                                your mail box.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>